import(/* webpackMode: "eager" */ "/app/src/app/(pages)/carrello/page.tsx");
